export default __webpack_public_path__ + "static/media/SIFA_FR_SEQ13.2e6b0d80.mp3";